import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import AvatarIcon from "@/assets/images/pictures/avatar_placeholder.svg?inline";
import EditIcon from "@/assets/images/icons/edit.svg?inline";
import PrintIcon from "@/assets/images/icons/print.svg?inline";

import { mapGetters, mapState } from "vuex";

import { BUYER_PROFILE, GENERATE_BUYER_PDF } from "../gql/UserProfileQueries";

import DesiredFeatures from "./components/DesiredFeatures";
import ImagePreferences from "./components/ImagePreferences";
import RecommendedHomes from "./components/RecommendedHomes";
import InterestedHomes from "./components/InterestedHomes";
import ClaimedHomes from "./components/ClaimedHomes";

import BuyLeadButton from "@/views/agent/Leads/components/BuyLeadButton";

// import Vue from "vue";
// import VueCalendly from "vue-calendly";

// Vue.use(VueCalendly);

export default {
  name: "public_user_profile",

  data() {
    return {
      buyerProfile: {},

      lead: {
        id: ""
      },

      isShowCalendly: false,

      isOwner: false,
      canBeBought: false,
      isLeadSold: false,
      isAgentWhoBought: false
    };
  },

  apollo: {
    buyerProfile: {
      query: BUYER_PROFILE,
      fetchPolicy: "no-cache",
      variables() {
        return {
          id: this.$route.params.id
        };
      },

      result(data) {
        if (!data.error) {
          this.checkUserStatus();
          this.lead.id = this.buyerProfile.userInfo.id;
        } else {
          this.$router.replace({
            name: "404"
          });
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    ...mapState(["twilioMessagesCounter"]),

    isMessagesAvaliable() {
      return this.twilioMessagesCounter != null;
    },

    // checkLeadType() {
    //   if (this.buyerProfile.userInfo.leadType === "hot") {
    //     return "Hot 🔥";
    //   } else if (this.buyerProfile.userInfo.leadType === "very_hot") {
    //     return "Very Hot 🔥🔥";
    //   } else if (this.buyerProfile.userInfo.leadType === "super_hot") {
    //     return "Super Hot 🔥🔥🔥";
    //   }
    // },

    isShowAvatar() {
      if (this.buyerProfile.userInfo.avatar) {
        if (this.isOwner || this.isAgentWhoBought) {
          return true;
        }
      }
    }
  },

  methods: {
    checkUserStatus() {
      if (this.buyerProfile.userInfo.status === "can_be_bought") {
        return (this.canBeBought = true);
      } else if (this.buyerProfile.userInfo.status === "sold") {
        return (this.isLeadSold = true);
      } else if (this.buyerProfile.userInfo.status === "me") {
        return (this.isOwner = true);
      } else if (this.buyerProfile.userInfo.status === "bought") {
        return (this.isAgentWhoBought = true);
      }
    },

    showModal() {
      this.$refs['modalAgreement'].show();
    },

    hideModal() {
      this.$refs['modalAgreement'].hide();
    },

    acceptAgreement() {
      this.$apollo
        .mutate({
          mutation: GENERATE_BUYER_PDF,
          variables: {
            buyerId: this.lead.id
          }
        })
        .then(() => {
          this.hideModal();
          this.$toasted.success("Agent view was sent to your email!");
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;
          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        });
    }
  },

  watch: {},

  components: {
    AvatarIcon,
    EditIcon,
    PrintIcon,
    LoadingIcon,
    DesiredFeatures,
    ImagePreferences,
    RecommendedHomes,
    InterestedHomes,
    ClaimedHomes,
    BuyLeadButton
  }
};
